import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import React from "react";
import { formatFinance } from "../../../../utils/formatters";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

export const IndoorStats = ({ data, loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <RestaurantIcon sx={{ mr: 1, color: "primary.main" }} />
        <Typography variant="h6">Salão</Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Faturamento
          </Typography>
          <Typography variant="h5">{formatFinance(data.totalSales)}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Ticket Médio
          </Typography>
          <Typography variant="h5">
            {formatFinance(data.averageOrder)}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Clientes
          </Typography>
          <Typography variant="h5">
            {data.customerCount.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            vs. Período Anterior
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h5"
              sx={{
                color: data.percentChange >= 0 ? "success.main" : "error.main",
              }}
            >
              {data.percentChange.toFixed(1)}%
            </Typography>
            {data.percentChange >= 0 ? (
              <TrendingUpIcon sx={{ ml: 0.5, color: "success.main" }} />
            ) : (
              <TrendingDownIcon sx={{ ml: 0.5, color: "error.main" }} />
            )}
          </Box>
        </Grid>
      </Grid>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Por Refeição
      </Typography>

      <Box sx={{ height: 180 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data.mealDistribution}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={60}
              fill="#8884d8"
              dataKey="value"
              label={({ name, percent }) =>
                `${name} ${(percent * 100).toFixed(0)}%`
              }
            >
              {data.mealDistribution.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => [`${value.toFixed(1)}%`, "Porcentagem"]}
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
};
